import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  tolerancePercentageWrapper: {
    display: "flex",
    flex: 1,
    flexGrow: 1,
    padding: "24px",
    border: "1px solid #E4E7EC",
    borderRadius: 8,
  },
  section: {
    borderRadius: 8,
    border: "1px solid #E4E7EC",
  },
  formSwitch: {
    "& span": {
      color: "#308CDB !important",
    },
    "& span.MuiSwitch-track": {
      opacity: 0.2,
    },
  },
  tolerancePercentageFooter: {
    paddingTop: "auto",
  },
  button: {
    fontWeight: 700,
    fontFamily: "Inter",
  },
}));

export default styles;
